import React from 'react';
import { FormControl, InputLabel, MenuItem, Select } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { DOCUMENT, documentHeroSearchSx } from '../constants/documentTheme';

const PackageAgentFilter = ({ agents = [], value, onChange }) => {
  const { t } = useTranslation();
  if (agents.length < 2) return null;

  return (
    <FormControl
      size="small"
      data-testid="package-agent-filters"
      sx={{
        mb: 3,
        minWidth: { xs: '100%', sm: 280 },
        maxWidth: 400,
        ...documentHeroSearchSx,
      }}
    >
      <InputLabel id="package-agent-filter-label">{t('packagesPage.filterByAgent')}</InputLabel>
      <Select
        labelId="package-agent-filter-label"
        label={t('packagesPage.filterByAgent')}
        value={value == null ? '' : String(value)}
        onChange={(event) => onChange(event.target.value)}
        MenuProps={{
          PaperProps: {
            sx: {
              maxHeight: 360,
              borderRadius: 0,
              border: `1px solid ${DOCUMENT.ruleHard}`,
            },
          },
        }}
      >
        <MenuItem value="">{t('packagesPage.allAgents')}</MenuItem>
        {agents.map((agent) => (
          <MenuItem key={agent.id} value={String(agent.id)}>
            {agent.name}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
};

export default PackageAgentFilter;
